import {Component, OnInit} from '@angular/core';
import {MatToolbar, MatToolbarRow} from '@angular/material/toolbar';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [
        MatToolbar,
        MatToolbarRow,
        MatButton
    ],
    standalone: true
})

export class FooterComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }
}
